// Style for table data loader
const Style = () => ({
  placeholderSkeleton: {
    marginTop: 5,
    marginBottom: 5,
  },
});

export default Style;
